export default __webpack_public_path__ + "static/media/dark-roof.f856718e.png";